import React, { ReactNode } from "react"
import { i18n } from "@lingui/core"

import type { TokenValueEncoded, TokenValuePercentage } from "@silversea-ssc/dotcom-read-model-types/Tokens"
import { FormatDateFormat, toUTCDate } from "../../app-core/_common/format/date"
import DateOnlyFormat from "../DateOnlyFormat"

const numberFormatOptions = (currency: string): Intl.NumberFormatOptions => ({
    style: "currency",
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
})

const dateFormatOptions: FormatDateFormat = {
    year: "numeric",
    month: "short",
    day: "numeric",
}

function formattedValue(_placeholder: string, value: TokenValueEncoded): JSX.Element {
    switch (value.type) {
        case "date":
            return <DateOnlyFormat value={toUTCDate(value.date as string)} format={dateFormatOptions} />

        case "percentage":
            return <React.Fragment>{formatPercentage(value)}</React.Fragment>

        case "amount":
            return <React.Fragment>{i18n.number(value.amount, numberFormatOptions(value.currency))}</React.Fragment>
        case "string":
            return <React.Fragment>{value.value}</React.Fragment>
        default:
            return <React.Fragment></React.Fragment>
    }
}

const formatPercentage = (token: TokenValuePercentage): string => `${token.percentage}%`

interface PlaceholderValuesFormatterProps {
    placeholder: string
    value: TokenValueEncoded
}

const PlaceholderValuesFormatter: React.FC<React.PropsWithChildren<PlaceholderValuesFormatterProps>> = ({
    placeholder,
    value,
}) => {
    if (!value) return <React.Fragment>{placeholder}</React.Fragment>

    return <React.Fragment>{formattedValue(placeholder, value)}</React.Fragment>
}

export function renderPlaceholderValue(placeholder: string, value: TokenValueEncoded): ReactNode {
    return <PlaceholderValuesFormatter key={`${placeholder}`} placeholder={placeholder} value={value} />
}
